import { formaters } from "vincent-utils";
import { ExistingPatient, Transforms } from "cadendar-shared";
import classNames from "classnames";
import Select from "../../baseComps/Select.tsx";

interface ChoosePatientDialogProps {
  onChoosePatient: (patientId: string | null) => void;
  onCancel: () => void;
  patientSelectedId: string | null;
  onSetSearch: (search: string) => void;
  search: string;
  candidates: ExistingPatient[];
}

interface LensIconProps {
  className?: string;
}
const LensIcon = (props: LensIconProps) => (
  <>
    <svg
      className={props.className}
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9604 11.4802C19.9604 13.8094 19.0227 15.9176 17.5019 17.4512C16.9332 18.0247 16.2834 18.5173 15.5716 18.9102C14.3594 19.5793 12.9658 19.9604 11.4802 19.9604C6.79672 19.9604 3 16.1637 3 11.4802C3 6.79672 6.79672 3 11.4802 3C16.1637 3 19.9604 6.79672 19.9604 11.4802Z"
        strokeWidth="2"
      />
      <path
        d="M18.1553 18.1553L21.8871 21.8871"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </>
);

// const formLabelTextStyle = cva({
//   base: {
//     fontFamily: "Open Sans",
//     fontSize: 16,
//     fontWeight: 600,
//     cursor: "pointer",
//   },
//   variants: {
//     disabled: {
//       true: {
//         color: "gray.400",
//         cursor: "not-allowed",
//       },
//     },
//   },
// });

const candidateStyle = (selected: boolean) =>
  classNames(
    "my-2 cursor-pointer p-1 font-['Open_Sans'] text-[16px] font-normal",
    selected && "bg-blue-100",
  );

const ChoosePatientDialog = (props: ChoosePatientDialogProps) => {
  const { search, candidates: patients } = props;
  const handleSetSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onSetSearch(event.target.value);
  };
  const sorter = Transforms.patients.curriedSpecialSort(search);
  const sortedCandidates = [...(patients || [])].sort(sorter);

  return (
    <div className="w-full bg-gray-50">
      <div className="m-2 border-2 border-gray-200 border-none py-3">
        <div className="text-center text-[16px] font-bold">
          Recherche d'un patient existant
        </div>
        <div className="mt-2 flex justify-center">
          <div className="relative top-0 left-0 w-[95%]">
            <LensIcon className="absolute top-2 right-2 h-[1.5em] w-[1.5em] stroke-black" />
            <input
              type="text"
              value={search}
              id={"patientLookupInput"}
              className="h-[2.5em] w-full rounded border-2 border-gray-100 bg-white p-1"
              placeholder="Nom du patient"
              onChange={handleSetSearch}
            />
          </div>
        </div>
        <div className="mt-2 flex justify-center">
          <div className="mt-2 w-[95%]">
            {sortedCandidates.length > 0 && (
              <Select
                className="w-full"
                onChange={(event) =>
                  props.onChoosePatient(event.target.value || null)
                }
                value={props.patientSelectedId || ""}
              >
                <option value="">Sélectionner un patient</option>
                {sortedCandidates.map((patient) => (
                  <option
                    key={patient.id}
                    className={candidateStyle(
                      props.patientSelectedId === patient.id,
                    )}
                    value={patient.id}
                  >
                    {formaters.capitaliseEveryFirstLetter(patient.name)}{" "}
                    {formaters.capitaliseEveryFirstLetter(patient.forename)}
                  </option>
                ))}
              </Select>
            )}
          </div>
          {/*{sortedCandidates.map((patient) => (*/}
          {/*  <li*/}
          {/*    key={patient._id}*/}
          {/*    onClick={() => props.onChoosePatient(patient._id)}*/}
          {/*    className={candidateStyle({*/}
          {/*      selected: props.patientSelectedId === patient._id,*/}
          {/*    })}*/}
          {/*  >*/}
          {/*    <span*/}
          {/*      className={css({*/}
          {/*        display: "inline-block",*/}
          {/*        fontWeight: 600,*/}
          {/*        _firstLetter: {*/}
          {/*          textTransform: "uppercase",*/}
          {/*        },*/}
          {/*      })}*/}
          {/*    >*/}
          {/*      {patient.nom}*/}
          {/*    </span>*/}
          {/*    <span*/}
          {/*      className={css({*/}
          {/*        display: "inline-block",*/}
          {/*        _firstLetter: {*/}
          {/*          textTransform: "uppercase",*/}
          {/*        },*/}
          {/*      })}*/}
          {/*    >*/}
          {/*      {patient.prenom}*/}
          {/*    </span>*/}
          {/*  </li>*/}
          {/*))}*/}
        </div>
      </div>
    </div>
  );
};

export default ChoosePatientDialog;
